/* eslint-disable no-shadow */
/* eslint-disable react/prop-types */

import React from 'react';
import {
	Input
} from 'reactstrap';
import PropTypes from 'prop-types';

import guid from 'Utils/guid';
import Icon from '../Icon/Icon';

const SelectDropdown = props => {
	const {
		menuItems,
		groups,
		selectedIndex,
		selectCallback,
		className,
		label,
		id,
		altersDataLabel,
		maxWidth,
		minWidth,
		hideLabel,
		inputName,
		disabled,
		labelLocation,
		arialabelledBy
	} = props;

	const toggle = event => {
		selectCallback(Number(event.target.value));
	};

	const chevron = (
		<Icon
			iconName="chevron"
			className={`menu-open ${className} ${disabled ? 'disabled' : ''}`}
			altText="open links menu"
			style={{ width: 14 }} />
	);

	const createOptions = (items, offset = 0) => {
		return items && items.length > 0
			? items.map((item, index) => {
				const itemKey = `${item.key}-${index}`;
				return (
					<option
						value={index + offset}
						key={itemKey}>
						{item.label}
					</option>
				);
			}) : null;
	};

	const createGroups = (optGroups, items) => {
		let tempCount = 0;
		const groupings = [];
		optGroups.forEach(tempGroup => {
			const itemsFilteredByGroup = items.filter(item => item.group === tempGroup.group);
			groupings.push(
				<optgroup key={tempGroup.group} label={tempGroup.label}>
					{createOptions(itemsFilteredByGroup, tempCount)}
				</optgroup>
			);
			tempCount += itemsFilteredByGroup.length;
		});

		return groupings;
	};

	const buildOptions = () => {
		if (groups.length) {
			return createGroups(groups, menuItems);
		}
		return createOptions(menuItems);
	};

	const labelLocationClass = `label-pos-${labelLocation}`;
	const forId = id ? `select-for-${id}` : `select-for-${guid.getNewGuid()}`;
	const menuLabel = label
		? (
			<label htmlFor={forId} className={`${(hideLabel ? 'sr-only' : '')} ${(labelLocation ? labelLocationClass : '')}`}>
				{label}
			</label>
		) : null;

	return (
		<span className={`${className} select-dropdown`}>
			{menuLabel}
			<span className="input-wrapper" style={{ maxWidth, minWidth }}>
				<Input
					type="select"
					name={inputName}
					style={{ maxWidth, minWidth }}
					onChange={event => { toggle(event); }}
					id={forId}
					value={selectedIndex || 0}
					disabled={disabled}
					className={`${className} select-dropdown-button ${maxWidth ? 'limit' : ''}`}
					aria-labelledby={arialabelledBy}
					aria-describedby={altersDataLabel ? 'selection-alters-data' : null}>
					{buildOptions()}
				</Input>
				{chevron}
			</span>
		</span>
	);
};

/**
 * Helpful info for adding prop types
 * https://reactjs.org/docs/typechecking-with-proptypes.html#proptypes
 */
SelectDropdown.propTypes = {
	menuItems: PropTypes.arrayOf(PropTypes.shape({
		key: PropTypes.string,
		label: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
		active: PropTypes.bool
	})),
	groups: PropTypes.arrayOf(PropTypes.shape({
		group: PropTypes.string,
		label: PropTypes.string
	})),
	inputName: PropTypes.string,
	label: PropTypes.string,
	selectedIndex: PropTypes.number.isRequired,
	selectCallback: PropTypes.func.isRequired,
	className: PropTypes.string,
	id: PropTypes.string,
	altersDataLabel: PropTypes.bool,
	maxWidth: PropTypes.number,
	minWidth: PropTypes.number,
	hideLabel: PropTypes.bool,
	disabled: PropTypes.bool,
	labelLocation: PropTypes.string,
	arialabelledBy: PropTypes.string
};

SelectDropdown.defaultProps = {
	menuItems: [],
	groups: [],
	className: '',
	label: null,
	id: null,
	altersDataLabel: false,
	maxWidth: null,
	minWidth: null,
	hideLabel: false,
	inputName: null,
	disabled: false,
	labelLocation: null,
	arialabelledBy: null
};

export default SelectDropdown;
